import { baseApi } from "app/baseApi";
import { apiTags } from "app/store/apiTags";

const apiPrefix = 'vendorFeedback';
export const vendorFeedbackApi = baseApi.injectEndpoints({
    reducerPath: 'loadApi',
    endpoints: (builder) => ({
        getVendorFeedback: builder.query({
            query: (vendorId) => `${apiPrefix}/${vendorId}`,
            providesTags: (result, error, vendorId) =>
                result ?
                    [{ type: apiTags.VENDOR_FEEDBACK, id: vendorId }] :
                    [{ type: apiTags.VENDOR_FEEDBACK, id: 'LIST' }],
        }),
        addFeedback: builder.mutation({
            query: (body) => ({
                url: `${apiPrefix}`,
                method: "POST",
                body
            }),
            invalidatesTags: (result, error, arg) => [
                { type: apiTags.VENDOR_FEEDBACK },
                { type: apiTags.VMS, id: 'LIST' }],
        })
    })
});


export const { useAddFeedbackMutation, useGetVendorFeedbackQuery } = vendorFeedbackApi;
